import React from 'react'
import './footer.scss'

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div>
        &copy; {currentYear} Storyteller Overland, LLC. All Rights Reserved
      </div>
    </footer>
  );
}


